export const environment = {
  production: true,
  firebaseConfig: {
    apiKey: "AIzaSyC13YNk6z4I_84ItRDyiA5TJgIXDiGYSr0",
    authDomain: "recipe-book-f9427.firebaseapp.com",
    databaseURL: "https://recipe-book-f9427.firebaseio.com",
    projectId: "recipe-book-f9427",
    storageBucket: "recipe-book-f9427.appspot.com",
    messagingSenderId: "1063449219707",
    appId: "1:1063449219707:web:b385da85bc88a1c1ff48de",
    measurementId: "G-YGG37QBHVZ"
  }
};
